import React from "react";

const Activite = () => {
  const activities = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z" />
        </svg>
      ),
      title: "Fabrication d'équipements de lavage self-service et automatisés",
      desc: "Conception et fabrication de solutions de lavage innovantes destinées aux centres de lavage en libre-service, intégrant des technologies automatisées pour garantir performance, fiabilité et simplicité d'utilisation.",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
        </svg>
      ),
      title: "Conception et réalisation de prototypes industriels",
      desc: "Développement de prototypes et de modèles expérimentaux permettant de tester, valider et perfectionner de nouveaux produits avant leur mise en production.",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
        </svg>
      ),
      title: "Charpente métallique pour centres de lavage",
      desc: "Fabrication et assemblage de structures métalliques adaptées aux centres de lavage, incluant les pistes, supports d'équipements et installations techniques.",
    },
  ];

  return (
    <section className="w-full bg-white">
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {activities.map((act, i) => (
          <div
            key={i}
className="group relative flex flex-col px-6 sm:px-8 md:px-10 py-10 sm:py-12 md:py-14 border-b sm:border-b-0 sm:border-r border-gray-100 last:border-0 hover:bg-blue-600 transition-all duration-500 cursor-default overflow-hidden"          >

            {/* Icône dans un cercle */}
<div className="relative z-10 mb-6 w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 rounded-2xl bg-blue-50 group-hover:bg-white/20 flex items-center justify-center text-blue-600 group-hover:text-yellow-400 transition-all duration-500 shadow-sm">
              {act.icon}
            </div>

            {/* Titre */}
<h4 className="relative z-10 text-lg sm:text-xl font-bold text-gray-800 group-hover:text-white mb-3 leading-snug transition-colors duration-500">
                {act.title}
            </h4>

            {/* Ligne décorative */}
            <div className="relative z-10 w-12 h-1 bg-yellow-400 rounded-full mb-5 group-hover:w-20 transition-all duration-500" />

            {/* Description */}
<p className="relative z-10 text-sm sm:text-base text-gray-500 group-hover:text-blue-100 leading-relaxed transition-colors duration-500">
                {act.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Activite;